import React from 'react';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import './TwFileVisibility.scss';
export interface TwSelectOption {
  label: string;
  value: string;
}

export interface TwSelectProps {
  id?: string;

  /**
   * Callback fired when the value is changed.
   */
  onInputChange?: (e: SelectChangeEvent<string>) => void;
  /**
   * Select name.
   */
  name: string;

  /**
   * Select value
   */
  value: string | undefined;
}

const TwFileVisibilitySelect: React.FC<TwSelectProps> = ({ id, name, value, onInputChange }) => {
  const customArrow = (props: { [key: string]: string }): JSX.Element => {
    return <ExpandMoreIcon className={`${props.className} tw-file-visibility__icon`} />;
  };

  return (
    <Box sx={{ position: 'relative' }}>
      {value === 'visible' ? (
        <VisibilityIcon className="tw-file-visibility__icon" />
      ) : (
        <VisibilityOffIcon className="tw-file-visibility__icon" />
      )}
      <Select
        id={id}
        name={name}
        value={''}
        onChange={onInputChange}
        IconComponent={customArrow}
        MenuProps={{
          disablePortal: true
        }}
        className="tw-file-visibility__select"
      >
        <MenuItem className="tw-file-visibility__option" value={'visible'}>
          <VisibilityIcon className="tw-file-visibility__optionIcon" />
          Visible to driver
        </MenuItem>
        <MenuItem className="tw-file-visibility__option" value={'hidden'}>
          <VisibilityOffIcon className="tw-file-visibility__optionIcon" />
          Hidden from Driver
        </MenuItem>
      </Select>
    </Box>
  );
};

export default TwFileVisibilitySelect;
